import React from "react";
import { SectionArticle } from "../../shared/ArticleTemplate";

const Culture = ({parentPath}) =>
  <SectionArticle sectionName="culture" backRoute={parentPath}/>

export default Culture;